import { render, staticRenderFns } from "./GiftCardError.vue?vue&type=template&id=2d8624a8&scoped=true&"
import script from "./GiftCardError.vue?vue&type=script&lang=js&"
export * from "./GiftCardError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8624a8",
  null
  
)

export default component.exports